module.exports = {
    title: `irrationnelle`,
    description: `blog about development`,
    author: `irrationnelle`,
    introduction: `irrationnelle`,
    siteUrl: `https://dev.rase.blog`, // Your blog site url
    social: {
        twitter: ``, // Your Twitter account
        github: `irrationnelle`, // Your GitHub account
        medium: ``, // Your Medium account
        facebook: ``, // Your Facebook account
        linkedin: ``, // Your LinkedIn account
    },
    icon: `content/assets/felog.png`, // Add your favicon
    keywords: [`blog`],
    comment: {
        disqusShortName: '', // Your disqus-short-name. check disqus.com.
        utterances: 'irrationnelle/devlog', // Your repository for archive comment
    },
    configs: {
        countOfInitialPost: 10, // Config your initial count of post
    },
    sponsor: {
        buyMeACoffeeId: '',
    },
    share: {
        facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
    },
    ga: '', // Add your google analytics tranking ID
}
